/**
 * c-buy-now.js
 * 独自「今すぐ購入」(Buy Now) ボタン用ハンドラ。
 * product-form.liquid の [data-buy-now] ボタンに対して、
 * クリック時にフォーム内容を /cart/add.js で追加し、そのまま /checkout へ遷移する。
 *
 * - document へのイベント委譲なので、AJAX読み込みされるクイックビュー/クイックショップ内のボタンにも対応。
 * - product-form.liquid が複数回 render されてもリスナーは1度だけ登録（window フラグでガード）。
 */
(function () {
  if (window.__cBuyNowInit) return;
  window.__cBuyNowInit = true;

  function getRoot() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    return r.replace(/\/$/, '');
  }

  function buyNow(btn) {
    var form = btn.closest('form[data-type="add-to-cart-form"]') || btn.closest('form');
    if (!form) return;

    var root = getRoot();
    var spinner = btn.querySelector('.t4s-loading__spinner');

    btn.setAttribute('disabled', 'disabled');
    btn.setAttribute('aria-busy', 'true');
    if (spinner) spinner.removeAttribute('hidden');

    fetch(root + '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function () {
        window.location.href = root + '/checkout';
      })
      .catch(function (err) {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-busy');
        if (spinner) spinner.setAttribute('hidden', 'hidden');
        var msg = (err && (err.description || err.message)) || '商品をカートに追加できませんでした。在庫をご確認ください。';
        window.alert(msg);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-buy-now]');
    if (!btn || btn.hasAttribute('disabled')) return;
    e.preventDefault();
    buyNow(btn);
  });
})();
